<template>
    <div>
        <div class="mb-5 info-all-panel">
            <small>Общие показатели</small>
            <div>
                <i class="icon feather icon-bar-chart mr-2"></i> CPM <b>{{ ((this.selected.reduce((sum,item) => {return sum + item.cpm;},0))/this.selected.length).toFixed(0) }}</b><br>
                <i class="icon feather icon-users mr-2"></i> Подписчики <b>{{ (this.selected.reduce((sum,item) => {return sum + item.followers;},0)) }}</b><br>
                <i class="icon feather icon-eye mr-2"></i> Охват поста <b>{{ (this.selected.reduce((sum,item) => {return sum + item.postreach;},0)) }}</b><br>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-12" v-for="platform in selected">
                <div class="cell mb-5">
                    <div class="media">
                        <span class="pull-right price-info" v-if="!platform.bundle">
                            <span class="mr-2">{{ getPlatformPrice(platform) }}</span> <i class="fa fa-ruble"></i>
                        </span>
                        <span class="pull-right price-info" v-else>
                            <span class="mr-2">
                                <del style="color: #9d9d9d;">{{ getPlatformPriceWithoutDiscount(platform) }}</del>
                                {{ getPlatformPrice(platform) }}</span> <i class="fa fa-ruble"></i>
                        </span>
                        <div class="media-left">
                            <a :href="platform.group_id? 'https://vk.com/club'+platform.group_id : ''" target="_blank">
                                <img :src="platform.avatar" class="media-object group-avatar">
                            </a>
                            <span v-if="selected.length > 1" @click="deleteItemFromCart(platform)" class="deletePosition el-button el-button--danger is-circle">
                                <i class="feather icon-x"></i>
                            </span>
                        </div>
                        <div class="media-body" v-if="!platform.bundle">
                            <a :href="'https://vk.com/club'+platform.group_id" target="_blank">
                                <h4 class="media-heading">
                                    <span>
                                        {{ getTitle(platform.name) }}
                                    </span>
                                </h4>
                            </a>
                            <p class="m-0">{{ platform.category }}</p>
                            <p class="m-0">
                                <i class="feather icon-bar-chart mr-2"></i> {{ platform.cpm.toFixed(0) }} CPM
                                <i class="feather icon-users m-2"></i>{{ platform.followers }}
                                <span title="Охват поста"><i class="feather icon-eye m-2"></i>{{ platform.postreach }}</span>
                            </p>
                        </div>
                        <div class="media-body" v-else>
                            <h4 class="media-heading">
                                <span>
                                    {{ getTitle(platform.title) }}
                                </span>
                            </h4>
                            <p class="m-0">
                                <i class="feather icon-bar-chart mr-2"></i> {{ platform.cpm.toFixed(0) }} CPM
                                <i class="feather icon-users m-2"></i>{{ platform.followers }}
                                <span title="Охват поста">
                                    <i class="feather icon-eye m-2"></i>{{ platform.postreach }}
                                </span>
                            </p>
                            <platforms-spoiler-list
                                    :platforms="platform.platforms">
                            </platforms-spoiler-list>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="price-hr">
        <div class="row price-card">
            <div class="col-xs-6 text-left">
                Всего
            </div>
            <div class="col-xs-6 text-right">
                {{ getFinalPrice().toFixed(2) }} <i class="fa fa-ruble"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import PlatformsSpoilerList from "./PlatformsSpoilerList";

    export default {
        name: "selectedPlatformsList",
        props: {
            selected: Array,
            type: String,
            countTasks: Number
        },
        methods: {
            getPlatformPriceWithoutDiscount(platform) {
                if (this.type === "native") {
                    return platform.priceWithoutDiscount * this.countTasks;
                } else if (this.type === 'direct') {
                    return platform.directAdsPriceWithoutDiscount * this.countTasks;
                } else if (this.type === 'story') {
                    return platform.storyPriceWithoutDiscount * this.countTasks;
                }
            },
            getPlatformPrice(platform) {
                if (this.type === "native") {
                    return platform.price * this.countTasks;
                } else if (this.type === 'direct') {
                    return platform.directads_price * this.countTasks;
                } else if (this.type === 'story') {
                    return platform.story_price * this.countTasks;
                }
            },
            getFinalPrice() {
                return this.selected.reduce((sum,item) => {return sum + this.getPlatformPrice(item);},0);
            },
            deleteItemFromCart(item) {
                this.$emit('deleteItemFromCart', item);
            },
            getTitle(title) {
                let name = title.substring(0, 30);
                name += ' ' + title.length > 30?'...':'';
                return name;
            }
        },
        components: {
            'platforms-spoiler-list': PlatformsSpoilerList
        }
    }
</script>

<style scoped>
    .media-heading {
        font-size: 15px;
        color: black;
        font-weight: 400;
    }
    .price-hr {
        height: 6px;
        background: url(../../assets/hr-12.png) repeat-x 0 0;
        border: 0;
    }
    .price-card .text-right {
        font-size: 20px;
    }
    .price-card .text-left {
        font-size: 20px;
        line-height: 30px;
        font-weight: 100;
    }
    .price-info {
        line-height: 40px;
    }
    .deletePosition {
        position: absolute;
        top: 0;
        margin-left: 28px;
        color: white;
        padding: 3px!important;
        font-size: 9px!important;
    }
    .bonus-flag {
        position: absolute;
        bottom: 35px;
        margin-left: 21px;
        width: 12px;
        height: 12px;
        border: 2px solid #fff;
        background: #868e96;
        border-radius: 50%;
    }
    .el-pl-type {
        height: 17px;
        padding: 0 4px;
        line-height: 15px;
        margin-right: 4px;
    }
    .info-all-panel {
        padding: 11px;
        background: #f3f3f3;
        border-radius: 5px;
    }
    .group-avatar {
        max-width: 39px;
        border-radius: 50%;
        margin-right: 5px;
    }
</style>
